<deletemodal id="customer-tabs" [deleteModal]="deleteModal">
</deletemodal>
<modal #closeTicketModal>
    <modal-header class="color-blue">
        <h4 *ngIf="!isTicketClosed">{{'ticketing-system.CLOSE TICKET'|translate | translateKey}}</h4>
        <h4 *ngIf="isTicketClosed">{{'ticketing-system.REOPEN TICKET'|translate | translateKey}}</h4>
    </modal-header>
    <modal-content>
        <form *ngIf="ticketCloseForm" [formGroup]="ticketCloseForm" style="margin-left: -15px;width: 104%;"
            class="col-xs-12  ticket-color-validation" novalidate>
            <div class="form-group" *ngIf="!isTicketClosed">
                <label
                    for="{{'ticketing-system.Reason'|translate | translateKey}}">{{'ticketing-system.Reason'|translate | translateKey}}
                </label>
                <div>
                    <select autofocus tabindex="0" class="form-control" formControlName="closedTicketReason">
                        <option value="" [selected]="true">--{{'ticketing-system.Select'|translate | translateKey}}--
                        </option>
                        <option *ngFor="let reason of closedReasons" [value]="reason.id">{{reason.value}}</option>
                    </select>
                    <div class="alert-msg"
                        *ngIf="!ticketCloseForm.controls['closedTicketReason'].valid && ticketCloseForm.controls['closedTicketReason'].hasError('required') &&(ticketCloseForm.controls['closedTicketReason'].touched|| modelSubmit)">
                        <div *ngIf="ticketCloseForm.controls['closedTicketReason'].errors.required">
                            {{'validation-message.Required'|translate}}
                        </div>
                    </div>

                </div>
            </div>
            <div class="form-group">
                <label
                    for="{{'ticketing-system.Note'|translate | translateKey}}">{{'ticketing-system.Note'|translate | translateKey}}
                    <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Note'|translate | translateKey}}"></span> -->
                </label>
                <div class=" textarea-msg">
                    <textarea tabindex="0" class="form-control" placeholder="" formControlName="closedTicketNote"
                        rows="3"></textarea>
                    <div class="alert-msg"
                        *ngIf="!ticketCloseForm.controls['closedTicketNote'].valid && ticketCloseForm.controls['closedTicketNote'].hasError('required') &&(ticketCloseForm.controls['closedTicketNote'].touched|| modelSubmit)">
                        <div *ngIf="ticketCloseForm.controls['closedTicketNote'].errors.required">
                            {{'validation-message.Required'|translate}}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </modal-content>
    <modal-footer>
        <div class="pull-right">
            <div *ngIf="!isTicketClosed" class="btn-group  btn-save-new">
                <button class="btn btn-default btn-save blue-button" type="submit" tabindex="0" (click)="closeTicket()">
                    {{'ticketing-system.Save'|translate | translateKey}}</button>
            </div>
            <div *ngIf="isTicketClosed" class="btn-group  btn-save-new">
                <button class="btn btn-default btn-save blue-button" type="submit" tabindex="0"
                    (click)="reopenTicket()">
                    {{'ticketing-system.Save'|translate | translateKey}}</button>
            </div>
            <button class="btn cancel btn-cancel grey-button" type="button" tabindex="0" (keyup.enter)="cancelPopup()"
                (click)="cancelPopup()">
                {{'ticketing-system.Cancel'|translate | translateKey}}
            </button>
        </div>
    </modal-footer>
</modal>
<section class="container">
    <!-- end -->
    <div *ngIf="ticketingModel" class="position-relative">
        <div class="row clearboth distributorInfo mt-20">
            <div *ngIf="ticketingModel.ticketNumber" class="bold header-font color-black">
                {{'ticketing-system.Ticket'|translate | translateKey | titleCase}}-{{ticketingModel.ticketNumber| titleCase}}
                | {{ticketingModel.statusValue}}
            </div>
        </div>
        <div class="col-md-9 left-padding-0 form-horizontal mt-30">
            <form *ngIf="ticketEditForm" [formGroup]="ticketEditForm" (ngSubmit)="updateTicket()" id="Update-Ticket-js">


                <!-- 1st COlumn -->
                <div class="col-xs-12 col-md-6 left-padding-0">
                    <!-- Ticket Type -->


                    <!-- Operating Country -->
                    <div class="">
                        <label for="operatingCountry"
                            class="control-label col-xs-5">{{'ticketing-system.Assigned to Country' |translate | translateKey}}</label>
                        <div class="col-xs-7  floating-input">
                            <select autofocus tabindex="0" formControlName="operatingCountry" class="form-control"
                                (change)="operatingCountryChange($event.target.value, true)">
                                <option *ngFor="let country of countries | orderBy:'name'" [value]="country.id">
                                    {{country.name}}</option>
                            </select>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['operatingCountry'].valid && ticketEditForm.controls['operatingCountry'].hasError('required') &&(ticketEditForm.controls['operatingCountry'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate | translateKey}}
                            </div>
                        </div>
                    </div>
                    <!-- Country -->
                    <div class="">
                        <label for="country"
                            class="control-label col-xs-5">{{'ticketing-system.Country'|translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input">
                            <select tabindex="0" formControlName="country" class="form-control"
                                (change)="getCountryIsoCodeThree($event.target.value, true)">
                                <option value="" [selected]="true">
                                    --{{'ticketing-system.Select' |translate | translateKey}}--</option>
                                <option *ngFor="let country of allCountries | orderBy:'name'"
                                    [value]="country.countryCode">
                                    {{country.countryName}}</option>
                            </select>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['country'].valid && ticketEditForm.controls['country'].hasError('required') &&(ticketEditForm.controls['country'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate | translateKey}}
                            </div>
                        </div>
                    </div>


                    <!-- Operating Country
                         <div class="">
                            <label for="countryOffice"  class="control-label col-xs-5">{{'ticketing-system.Country Office' |translate | translateKey}}</label>
                            <div class="col-xs-7  floating-input">
                              <select autofocus tabindex="0" formControlName="countryOffice" class="form-control" (change)="operatingCountryChange($event.target.value, true)">
                                <option *ngFor="let country of countries | orderBy:'name'" [value]="country.id">{{country.name}}</option>
                              </select>
                              <div class="alert-msg" *ngIf="!ticketEditForm.controls['countryOffice'].valid && ticketEditForm.controls['countryOffice'].hasError('required') &&(ticketEditForm.controls['countryOffice'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate | translateKey}}
                              </div>
                            </div>
                          </div>       -->

                    <div class="">
                        <label for="ticketType"
                            class="control-label col-xs-5">{{'ticketing-system.Ticket Type'|translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input">
                            <select #ticketType id="ticketType" tabindex="0" formControlName="ticketType"
                                (change)="getSubTypes($event.target.value)" class="form-control">
                                <option value="">--{{'ticketing-system.Select'|translate | translateKey}}--</option>
                                <option *ngFor="let ticketType of ticketTypes  | orderBy : 'sortValue'"
                                    [value]="ticketType.id">{{ticketType.value}}</option>
                            </select>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['ticketType'].valid && ticketEditForm.controls['ticketType'].hasError('required') &&(ticketEditForm.controls['ticketType'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate}}
                            </div>
                        </div>
                    </div>
                    <!-- Order ID -->
                    <div class="">
                        <label for="orderId"
                            class="control-label col-xs-5">{{'ticketing-system.Web Order Number'|translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input floatLabelContainer">
                            <input float-label tabindex="0" formControlName="orderId" class="form-control"
                                [ngClass]="{'sponsor-border-color': inValidOrderNumber}"
                                placeholder="{{'ticketing-system.Web Order Number'|translate | translateKey}}"
                                tabindex="0" type="text"
                                (blur)="getRecentOrderInformation()"  (focus)= "onFocusOrderId()">  
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['orderId'].valid && ticketEditForm.controls['orderId'].hasError('numericValidation') &&(ticketEditForm.controls['orderId'].touched|| isSubmitted)">
                                {{'validation-message.Enter valid Order ID'|translate}}
                            </div>
                            <div *ngIf="inValidOrderNumber && ticketEditForm.controls['orderId'].value"
                                class="alert-msg">
                                <div>{{'ticketing-system.Invalid Order Number'|translate | translateKey}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- Sub Type -->
                    <div class="">
                        <label for="subType"
                            class="control-label col-xs-5">{{'ticketing-system.SubType'|translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input">
                            <select tabindex="0" formControlName="subType" class="form-control">
                                <option value="">--{{'ticketing-system.Select'|translate | translateKey}}--</option>
                                <option *ngFor="let subType of subTypes | orderBy : 'name'" [value]="subType.id">
                                    {{subType.name}}</option>
                            </select>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['subType'].valid && ticketEditForm.controls['subType'].hasError('required') &&(ticketEditForm.controls['subType'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate}}
                            </div>
                        </div>
                    </div>
                    <!-- Department Name -->
                    <div class="">
                        <label for="department"
                            class="control-label col-xs-5">{{'ticketing-system.Assign to Department'|translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input">
                            <select tabindex="0" formControlName="department"
                                (change)="getAssignedUsersByDepartments($event.target.value)" class="form-control">
                                <option value="">--{{'ticketing-system.Select'|translate | translateKey}}--</option>
                                <option *ngFor="let department of departments" [value]="department.id">
                                    {{department.value}}</option>
                            </select>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['department'].valid && ticketEditForm.controls['department'].hasError('required') &&(ticketEditForm.controls['department'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate}}
                            </div>
                        </div>
                    </div>
                    <!-- Assign To -->
                    <div class="">
                        <label for="assignTo"
                            class="control-label col-xs-5">{{'ticketing-system.Assign to User'|translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input floatLabelContainer">
                            <select tabindex="0" formControlName="assignTo" class="form-control"
                                disabled="{{!isTicketAssign}}" (change)="assignToChange()">
                                <option value="">--{{'ticketing-system.Select'|translate | translateKey}}--</option>
                                <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
                            </select>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['assignTo'].valid && ticketEditForm.controls['assignTo'].hasError('required') &&(ticketEditForm.controls['assignTo'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate}}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 2nd Column -->
                <div class="col-xs-12 col-md-6">
                    <!-- Due Date -->
                    <div class="">
                        <label for="dueDate"
                            class="control-label col-xs-5">{{'ticketing-system.Due Date' | translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input floatLabelContainer">
                            <input #dueDate [owlDateTime]="dt3" class="form-control"
                                placeholder="{{'customer-service.Due Date dd-mmm-yyyy'|translate | translateKey}}"
                                formControlName="dueDate" tabindex="0" maxlength="11" appRestrictSpecialCharacters
                                float-label DateFormat
                                (blur)="workTicketEditTransformDate(ticketEditForm.controls['dueDate'].value)"
                                (dateTimeChange)="workTicketEditTransformDate(ticketEditForm.controls['dueDate'].value)">
                            <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt3></owl-date-time>
                            <span *ngIf="showDatePicker" [owlDateTimeTrigger]="dt3">
                                <span class="fa fa-calendar calendar-icon select-pointer"></span>
                            </span>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['dueDate'].valid && ticketEditForm.controls['dueDate'].hasError('dateValidation') && dueDate.value.length > 1">
                                {{'validation-message.Enter valid Date'|translate}}
                            </div>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['dueDate'].valid && ticketEditForm.controls['dueDate'].hasError('lessThanCurrentDate')">
                                {{'validation-message.Should be greater than current Date'|translate}}
                            </div>
                        </div>
                    </div>
                    <!-- Priority -->
                    <div class="">
                        <label for="priority"
                            class="control-label col-xs-5">{{'ticketing-system.Priority'|translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input">
                            <select tabindex="0" formControlName="priority" class="form-control">
                                <option value="">--{{'ticketing-system.Select'|translate | translateKey}}--</option>
                                <option *ngFor="let ticketPriority of ticketPriorities" [ngValue]="ticketPriority.id">
                                    {{ticketPriority.value }}</option>
                            </select>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['priority'].valid && ticketEditForm.controls['priority'].hasError('required') &&(ticketEditForm.controls['priority'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate}}
                            </div>
                        </div>
                    </div>
                    <!-- Location type -->
                    <div class="">
                        <label for="locationType"
                            class="control-label col-xs-5">{{'ticketing-system.Location Type'|translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input">
                            <select tabindex="0" formControlName="locationType" class="form-control"
                                [attr.disabled]="enableLocationType?null:''">
                                <option value="">--{{'ticketing-system.Select' |translate| translateKey}}--</option>
                                <option *ngFor="let locationType of locationTypes | orderBy : 'value'"
                                    [value]="locationType.id">{{locationType.value}}</option>
                            </select>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['locationType'].valid && ticketEditForm.controls['locationType'].hasError('required') &&(ticketEditForm.controls['locationType'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate}}
                            </div>
                        </div>
                    </div>
                    <!-- Status -->
                    <div class="">
                        <label for="status"
                            class="control-label col-xs-5">{{'ticketing-system.Status'|translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input">
                            <select tabindex="0" formControlName="status" class="form-control">
                                <option value="">--{{'ticketing-system.Select'|translate | translateKey}}--</option>
                                <option *ngFor="let status of statuses" [value]="status.id">{{status.value}}</option>
                            </select>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['status'].valid && ticketEditForm.controls['status'].hasError('required') &&(ticketEditForm.controls['status'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate}}
                            </div>
                        </div>
                    </div>
                    <!-- Mobile Number -->
                    <div class="" *ngIf="!this.isEmail">
                        <label *ngIf="ticketEditForm.controls['source'].value === sourceTypesEnum.Phone"
                            for="sourceIdentifierValue"
                            class="control-label col-xs-5">{{'ticketing-system.Phone Number' |translate | translateKey}}</label>
                        <div *ngIf="ticketEditForm.controls['source'].value === sourceTypesEnum.Phone"
                            class="col-xs-7 floating-input floatLabelContainer">
                            <input float-label tabindex="0" [mask]="phoneNumberFormat"
                                formControlName="sourceIdentifierValue" class="form-control"
                                placeholder="{{'ticketing-system.Caller Phone Number' |translate | translateKey}}"
                                tabindex="0" type="text">
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['sourceIdentifierValue'].valid && ticketEditForm.controls['sourceIdentifierValue'].hasError('required') &&(ticketEditForm.controls['sourceIdentifierValue'].touched|| isSubmitted)">
                                {{'validation-message.Required'|translate | translateKey}}
                            </div>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['sourceIdentifierValue'].valid && ticketEditForm.controls['sourceIdentifierValue'].hasError('phoneNumberValidation') && !ticketEditForm.controls['sourceIdentifierValue'].hasError('required') &&(ticketEditForm.controls['sourceIdentifierValue'].touched|| isSubmitted)">
                                {{'validation-message.Enter valid Phone Number'|translate | translateKey}}
                            </div>
                            <div class="alert-msg"
                                *ngIf="!ticketEditForm.controls['sourceIdentifierValue'].valid && ticketEditForm.controls['sourceIdentifierValue'].hasError('phoneNumberLengthValidation') && !ticketEditForm.controls['sourceIdentifierValue'].hasError('required') &&(ticketEditForm.controls['sourceIdentifierValue'].touched|| isSubmitted)">
                                {{'validation-message.Minimum Length should be 10 characters'|translate | translateKey}}
                            </div>
                        </div>
                    </div>
                    <!-- Member ID -->
                    <div class="">
                        <label for="Member ID"
                            class="control-label col-xs-5">{{'ticketing-system.Member ID'|translate | translateKey}}</label>
                        <div class="col-xs-7 floating-input floatLabelContainer">
                            <input float-label tabindex="0" formControlName="memberId" class="form-control"
                                [ngClass]="{'sponsor-border-color': invalidMembersearch}"
                                placeholder="{{'ticketing-system.Member ID'|translate | translateKey}}" tabindex="0"
                                type="text" (blur)="searchMemberByFboId()">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-6"></div>
                    <div class="col-xs-12 col-md-6">
                        <div class="">
                            <label class="col-xs-5">&nbsp;</label>
                            <div class="col-xs-7">
                                <div *ngIf="fboIdFound" class="member-exist">
                                    <div>{{'ticketing-system.Match found'|translate | translateKey}}:
                                        {{workTicketDistributorInfo?.name}}</div>
                                    <div>{{'ticketing-system.FBO ID'|translate | translateKey}}:
                                        {{workTicketDistributorInfo?.distributorId}}</div>
                                </div>
                                <div *ngIf="invalidMembersearch" class="member-not-exist">
                                    <div>{{'ticketing-system.Invalid Member ID'|translate | translateKey}}</div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 copy_to__block pr-42">
                        <tag-input name="copyTo" [formControlName]="'copyTo'" [onlyFromAutocomplete]="true"
                            [allowDupes]="false" [displayBy]="'displayName'" [identifyBy]="'displayName'"
                            [dynamicUpdate]="true" [editable]='true' [separatorKeyCodes]="[188,186,13]"
                            [placeholder]="'Copy To'" [secondaryPlaceholder]="'Copy To'" [addOnPaste]="false"
                            [addOnBlur]="true" [pasteSplitPattern]="splitPattern" theme='bootstrap'>
                            <tag-input-dropdown [autocompleteObservable]='requestAutocompleteItems'
                                [appendToBody]="false" [dynamicUpdate]="false" [identifyBy]="'displayName'">
                                <ng-template let-item="item" let-index="index">
                                    {{item.firstName}} {{item.lastName}} ({{item.username}})
                                </ng-template>
                            </tag-input-dropdown>
                        </tag-input>
                    </div>
                    <div class="col-md-12  floatLabelContainer pr-42 section-separator">
                        <input float-label tabindex="0" type="text" formControlName="subject" [readonly]="true"
                            class="form-control" placeholder="{{'ticketing-system.Subject'|translate | translateKey}}">
                        <div class="alert-msg"
                            *ngIf="!ticketEditForm.controls['subject'].valid && ticketEditForm.controls['subject'].hasError('required') &&(ticketEditForm.controls['subject'].touched|| isSubmitted)">
                            <div *ngIf="ticketEditForm.controls['subject'].errors.required">
                                {{'validation-message.Required'|translate}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 floating-input floatLabelContainer pr-42 section-separator">
                        <div class="floating-label">
                            <label class="static-floating-label">{{'ticketing-system.Description'| translate}}</label>
                            <div class="edit_ticket__description mb-0 pre-styles word-break--overflow"
                                [embedHTML]="ticketEditForm.controls['description'].value | replaceLinks | safeHtml">
                            </div>
                        </div>

                        <div class="alert-msg"
                            *ngIf="!ticketEditForm.controls['description'].valid && ticketEditForm.controls['description'].hasError('required') &&(ticketEditForm.controls['description'].touched|| isSubmitted)">
                            <div *ngIf="ticketEditForm.controls['description'].errors.required">
                                {{'validation-message.Required'|translate}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 floating-input floatLabelContainer pr-42">
                        <textarea float-label tabindex="0" class="form-control overflow-x-hidden noMarginBottom"
                            formControlName="notes" *ngIf="isTicketAddNoteNotes" id="notes"
                            placeholder="{{'ticketing-system.Notes'|translate}}" [maxlength]="maxDescriptionChars"
                            (focus)="descriptionFocus = true" rows="5"></textarea>
                        <small *ngIf="!descriptionFocus" class="">{{'ticketing-system.Max ||max|| characters' | translate | translateKey :
                                    {'max':maxDescriptionChars } }}</small>
                        <small *ngIf="descriptionFocus"
                            class="">{{ 'ticketing-system.||currentLength|| of ||max|| characters' | translate | translateKey : 
                                   {'currentLength': ticketEditForm.value.notes ? ticketEditForm.value.notes.length : 0, 'max': maxDescriptionChars} }}
                        </small>
                        <div class="alert-msg"
                            *ngIf="!ticketEditForm.controls['notes'].valid && ticketEditForm.controls['notes'].hasError('required') &&(ticketEditForm.controls['notes'].touched|| isSubmitted)">
                            <div *ngIf="ticketEditForm.controls['notes'].errors.required">
                                {{'validation-message.Required'|translate}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row-sameheight-block section-separator">
                    <div *ngIf="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId)"
                        class="col-xs-12 col-md-5 pad-top-10 column-equal no-padding overflow-auto">
                        <div class="table-section">
                            <table class="table table-striped custab">
                                <thead>
                                    <tr>
                                        <th>{{'ticketing-system.File Name'|translate | translateKey}}&nbsp;</th>
                                        <th>{{'ticketing-system.Actions'|translate | translateKey}}&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="uploader?.queue?.length">
                                    <tr *ngFor="let item of uploader.queue">
                                        <td>{{ item?.file?.name }}</td>
                                        <td class="options">
                                            <i class="line-height1-2 fa fa-trash"
                                                (click)="item.remove();attachmentsLength= attachmentsLength-1;"
                                                title="{{'ticketing-system.Delete'|translate}}">
                                            </i>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="existFiles?.length">
                                    <tr *ngFor="let item of existFiles,let i=index">
                                        <td>{{item.fileName}}</td>
                                        <td class="text-center options">
                                            <i class="fa text-primary fa-download pr-10"
                                                (click)="downloadDocument(item.url,item.fileName)"
                                                title="{{'documentlibrary.download '|translate | translateKey}}">
                                            </i>
                                            <i class="line-height1-2 fa fa-trash" (click)="removeExistFiles(item.key,i)"
                                                title="{{'ticketing-system.Delete'|translate}}">
                                            </i>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody>
                                    <tr>
                                        <td colspan="2" class="text-align-center">
                                            {{'ticketing-system.Max 5 attachments allowed'|translate | translateKey}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-7 pad-top-10 column-equal">
                        <label
                            *ngIf="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId) && !((uploader?.queue?.length + existFiles?.length)  >= 5)"
                            tabindex="0" (keyup.enter)="fileSelect.click()" for="attachFile"
                            class="mar-left10 line-height2 btn btn-xs browse-btn"
                            title="{{'ticketing-system.Choose File'|translate}}">
                            <span aria-hidden="true">{{'ticketing-system.Choose File'|translate}}</span>
                            <input #fileSelect type="file" id="attachFile" ng2FileSelect [uploader]="uploader"
                                [disabled]="attachmentsLength==5" (change)="checkMaxAttachments()" role="file"
                                aria-label="browse" style="display: none;" multiple>
                        </label>
                    </div>
                </div>
                <div class="row text-right pr-42 section-separator sticky">
                    <input float-label tabindex="1" type="checkbox"
                        formControlName="sendMailNotification" />{{'ticketing-system.Send mail for this update' |translate |translateKey}}
                    <span class="ico-help fa fa-question-circle"
                        title="{{'ticketing-system.By selecting this option, an update notification will be send' |translate |translateKey}}"></span>
                    <button [disabled]=" getValidationForUpdateBtn()" tabindex="0" type="submit"
                        class="btn blue-button">
                        {{'customer-service.UPDATE'|translate | translateKey}}
                    </button>
                    <button tabindex="0" type="button" (click)="openEditTicketCancelConfirmationPopup()"
                        (keyup.enter)="openEditTicketCancelConfirmationPopup()" class="btn grey-button">
                        {{'customer-service.CANCEL'|translate | translateKey}}
                    </button>
                </div>
                <!--  -->
                <div class="work-note-email section-separator">
                    <div class="note-email-tab">
                        <tabset>
                            <tab heading="Notes" id="tab1">
                                <div class="clearboth table-responsive mr-28 max-width-table-1300 worktickets-table">
                                    <table class="table table-striped custab">
                                        <thead>
                                            <tr>
                                                <th class="col-xs-2 pointer">
                                                    <strong>{{'customer-service.Time Stamp'|translate | translateKey}}&nbsp;
                                                        <i tabindex="0" (keyup.enter)="sortTableByColumn('createDate')"
                                                            (click)="sortTableByColumn('createDate')"
                                                            class="font-12 fa fa-sort"
                                                            [ngClass]="{'fa-sort': sortColumn != 'createDate', 'fa-sort-asc': (sortColumn  == 'createDate' && !isDesc), 'fa-sort-desc': (sortColumn  == 'createDate' && isDesc) }">
                                                        </i>
                                                    </strong>
                                                </th>
                                                <!-- <th>{{'ticketing-system.Time Stamp'|translate | translateKey}}&nbsp;</th> -->
                                                <th class="col-xs-2">
                                                    <strong>{{'customer-service.Created By' | translate | translateKey}}</strong>
                                                </th>
                                                <th class="col-xs-8">
                                                    {{'ticketing-system.Notes'|translate | translateKey}}&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let note of ticketingModel.notes ">
                                                <td>
                                                    {{note.createdDate}}
                                                </td>
                                                <td>{{note.createdByValue}}</td>
                                                <td id="notes-content" class="textarea-format" [innerHTML]="note.value | safeHtml"></td>
                                            </tr>
                                        </tbody>
                                        <tbody *ngIf="ticketingModel.notes?.length===0">
                                            <tr>
                                                <td colspan="3" class="text-center">
                                                    {{'customer-service.No Notes found on this ticket.' |translate |translateKey}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- <div class="pull-right">
                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                        </div> -->
                                </div>
                            </tab>
                            <tab heading="Emails">
                                <div class="clearboth table-responsive mr-28 max-width-table-1300 worktickets-table">
                                    <app-ticket-email-history [ticketID]="ticketID"></app-ticket-email-history>
                                </div>
                            </tab>
                        </tabset>
                    </div>
                </div>
                <div class="clearboth table-responsive mr-28 max-width-table-1300 worktickets-table">
                    <table class="table table-striped custab">
                        <thead>
                            <tr>
                                <th class="col-xs-2 pointer">
                                    <strong>{{'customer-service.Time Stamp'|translate | translateKey}}&nbsp;
                                        <i tabindex="0" (keyup.enter)="sortTableByColumn('createDate')"
                                            (click)="sortTableByColumn('createDate')" class="font-12 fa fa-sort"
                                            [ngClass]="{'fa-sort': sortColumn != 'createDate', 'fa-sort-asc': (sortColumn  == 'createDate' && !isDesc), 'fa-sort-desc': (sortColumn  == 'createDate' && isDesc) }">
                                        </i>
                                    </strong>
                                </th>
                                <th class="col-xs-2 pointer">
                                    <strong>{{'customer-service.User'|translate | translateKey}}&nbsp;
                                        <i tabindex="0" (keyup.enter)="sortTableByColumn('changedBy')"
                                            (click)="sortTableByColumn('changedBy')" class="font-12 fa fa-sort"
                                            [ngClass]="{'fa-sort': sortColumn != 'changedBy', 'fa-sort-asc': (sortColumn  == 'changedBy' && !isDesc), 'fa-sort-desc': (sortColumn  == 'changedBy' && isDesc) }">
                                        </i>
                                    </strong>
                                </th>
                                <th class="col-xs-1 pointer">
                                    <strong>{{'customer-service.Action'|translate | translateKey}}&nbsp;
                                        <i tabindex="0" (keyup.enter)="sortTableByColumn('actionType')"
                                            (click)="sortTableByColumn('actionType')" class="font-12 fa fa-sort"
                                            [ngClass]="{'fa-sort': sortColumn != 'actionType', 'fa-sort-asc': (sortColumn  == 'actionType' && !isDesc), 'fa-sort-desc': (sortColumn  == 'actionType' && isDesc) }">
                                        </i>
                                    </strong>
                                </th>
                                <th class="col-xs-5">
                                    <strong>{{'customer-service.Summary'|translate | translateKey}}&nbsp;
                                        <i tabindex="0">
                                        </i>
                                    </strong>
                                </th>
                                <th>
                                    <strong>{{'customer-service.Detail'|translate | translateKey}}&nbsp;
                                        <i tabindex="0">
                                        </i>
                                    </strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let log of ticketActivityLogList | paginate: { itemsPerPage: 5, currentPage: p }">
                                <td>
                                    {{log.createDate}}
                                </td>
                                <td>
                                    {{log.changedBy}}
                                </td>
                                <td>
                                    {{log.actionType}}
                                </td>
                                <td>
                                    <div class="textarea-format" [embedHTML]="log.summary |safeHtml"></div>
                                </td>
                                <td>
                                    <a *ngIf="log.changedData"
                                        (click)="openTicketActivityModal(log.changedData)">{{'customer-service.View Details..'|translate | translateKey}}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="ticketActivityLogList?.length===0">
                            <tr>
                                <td colspan="5" class="text-center">
                                    {{'customer-service.No Activity found on this ticket.' |translate |translateKey}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="pull-right">
                        <pagination-controls (pageChange)="p = $event"></pagination-controls>
                    </div>
                </div>
            </form>
        </div>
        <!-- Start account Restriction Popup-->
        <div *ngIf="accountRestriction">
            <account-restriction-popup [memberDetails]="memberDetails" (closeModal)="closeModal($event)"></account-restriction-popup>
        </div>
        <!-- End account Restriction Popup-->
        <div class="col-md-3 col-xs-12 business-owner-block right-padding-0 mt-30">
            <div>
                <ul class="list-group">
                    <li class="list-group-item  margin-0">
                        <div class="heading-section">
                            {{'ticketing-system.FOREVER BUSINESS OWNER'|translate | translateKey}}</div>
                        <div>
                            <div class="row">
                                <div class="col-md-4">
                                    <span>{{'ticketing-system.Name'|translate | translateKey}}</span>
                                </div>
                                <div *ngIf="workTicketDistributorInfo && workTicketDistributorInfo.name"
                                    class="col-md-8 text-right">
                                    <a (click)="navigateToFBOProfile()">
                                        <span>{{workTicketDistributorInfo.name}}</span></a>
                                </div>
                                <div *ngIf="(!workTicketDistributorInfo && !fboProfileDetail)||(workTicketDistributorInfo && !workTicketDistributorInfo.name)"
                                    class="col-md-8 text-right">
                                    <span>N/A</span>
                                </div>
                                <div *ngIf="!workTicketDistributorInfo && fboProfileDetail && fboProfileDetail.firstName"
                                    class="col-md-8 text-right">
                                    <a (click)="navigateToFBOProfile()">
                                        <span>{{fboProfileDetail | displayNameFormat}}</span></a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.FBO ID'|translate | translateKey}}</span>
                                </div>
                                <div *ngIf="workTicketDistributorInfo && workTicketDistributorInfo.distributorId"
                                    class="col-md-7 text-right">
                                    <a *ngIf="workTicketDistributorInfo?.distributorId"><i class="fa fa-copy"  [copyToClipboard]="workTicketDistributorInfo?.distributorId"></i></a>
                                    <a (click)="navigateToFBOProfile()">
                                        <span>{{workTicketDistributorInfo.distributorId |distributorIdFormat}}</span></a>
                                </div>
                                <div *ngIf="(!workTicketDistributorInfo && !fboProfileDetail)||(workTicketDistributorInfo && !workTicketDistributorInfo.distributorId)"
                                    class="col-md-7 text-right">
                                    <span>N/A</span>
                                </div>
                                <div *ngIf="!workTicketDistributorInfo && fboProfileDetail && fboProfileDetail.fboId"
                                    class="col-md-7 text-right">
                                    <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"  [copyToClipboard]="fboProfileDetail?.fboId"></i></a>
                                    <a (click)="navigateToFBOProfile()">
                                        <span>{{fboProfileDetail.fboId |distributorIdFormat}}</span></a>
                                </div>
                            </div>
                        </div>
                        <div class="heading-section pt-20">
                            {{'ticketing-system.TICKET DETAILS'|translate | translateKey}}</div>
                        <div>
                            <div class="row">
                                <div class="col-md-6 padding-left-14">
                                    <span>{{'ticketing-system.Operating Country' |translate | translateKey}}</span>
                                </div>
                                <div class="col-md-6 text-right">
                                    <span>{{ticketingModel.operatingCountryName | titlecase}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.Created By'|translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span>{{ticketingModel.createdByValue}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.Created Date'|translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span>{{ticketingModel.createdDate}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span
                                        *ngIf="sourceTypesEnum.Phone === ticketingModel.sourceId">{{'ticketing-system.Caller Name'|translate | translateKey}}</span>
                                    <span *ngIf="sourceTypesEnum.Email === ticketingModel.sourceId || sourceTypesEnum.Online_Form === ticketingModel.sourceId">Sender Name</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span *ngIf="ticketingModel.callerName">{{ticketingModel.callerName}}</span>
                                    <span *ngIf="!ticketingModel.callerName">N/A</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span
                                        *ngIf="sourceTypesEnum.Phone === ticketingModel.sourceId">{{'ticketing-system.Caller Phone Number'|translate | translateKey}}</span>
                                    <span *ngIf="sourceTypesEnum.Email === ticketingModel.sourceId || sourceTypesEnum.Online_Form === ticketingModel.sourceId">Sender Email</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span *ngIf="sourceTypesEnum.Phone === ticketingModel.sourceId">
                                        <span *ngIf="!ticketingModel.sourceIdentifierValue">N/A</span>
                                        <span
                                            *ngIf="ticketingModel.sourceIdentifierValue">{{ticketingModel.sourceIdentifierValue | mask:phoneNumberFormat}}</span>
                                    </span>
                                    <span *ngIf="sourceTypesEnum.Email === ticketingModel.sourceId || sourceTypesEnum.Online_Form === ticketingModel.sourceId">
                                        <span *ngIf="!ticketingModel.sourceIdentifierValue">N/A</span>
                                        <span
                                            *ngIf="ticketingModel.sourceIdentifierValue">{{ticketingModel.sourceIdentifierValue}}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.Source' |translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span *ngIf="sourceTypesEnum.Phone === ticketingModel.sourceId">
                                        {{'ticketing-system.Phone' |translate | translateKey}}
                                    </span>
                                    <span *ngIf="sourceTypesEnum.Email === ticketingModel.sourceId">
                                        {{'ticketing-system.Email' |translate | translateKey}}
                                    </span>
                                    <span *ngIf="sourceTypesEnum.Online_Form === ticketingModel.sourceId">
                                        {{'ticketing-system.Online Form' |translate | translateKey}}
                                    </span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.Assign to Dept'|translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span>{{ticketingModel.departmentName}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.Ticket Type'|translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span>{{ticketingModel.typeValue}}</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="orderInfo">
                            <div class="heading-section pt-20">
                                {{'ticketing-system.ORDER SUMMARY'|translate | translateKey}}</div>

                            <div>
                                <div class="row">
                                    <div class="col-md-7">
                                        <span>{{'ticketing-system.Web Order Number'|translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-5 text-right">
                                        <span>{{orderInfo.webOrderNumber}}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5">
                                        <span>{{'ticketing-system.Order Number'|translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-7 text-right">
                                        <span>{{orderInfo.orderNumber}}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5">
                                        <span>{{'ticketing-system.Order Date'|translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-7 text-right">
                                        <span>{{orderInfo.orderDate | date: 'dd-MMM-yyyy HH:mm:ss'}}</span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <span>{{'ticketing-system.Warehouse Name'|translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <span>{{orderInfo.shippingInfo.warehouseName}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="heading-section pt-20">{{'ticketing-system.DELIVERY'|translate | translateKey}}
                            </div>
                            <div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <span>{{'ticketing-system.Shipping Method'|translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <span>{{orderInfo.shippingInfo.shippingMethod}}</span>
                                    </div>
                                </div>
                                <div *ngIf="orderInfo && orderInfo.shippingInfo && orderInfo.shippingInfo.address"
                                    class="row">
                                    <div class="col-md-5">
                                        <span>{{'ticketing-system.Shipping Address'|translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-7 text-right"
                                        *ngIf="orderInfo.shippingInfo.address.addressFirstLine">
                                        {{orderInfo.shippingInfo.address.addressFirstLine | titlecase}}
                                    </div>
                                    <div class="col-md-7 text-right"
                                        *ngIf="orderInfo.shippingInfo.address.addressSecondLine">
                                        {{orderInfo.shippingInfo.address.addressSecondLine | titlecase}}
                                    </div>
                                    <div class="col-md-7 text-right"
                                        *ngIf="orderInfo.shippingInfo.address.addressThirdLine">
                                        {{orderInfo.shippingInfo.address.addressThirdLine | titlecase}}
                                    </div>
                                    <div *ngIf="orderInfo.shippingInfo.address.city"
                                        class="col-md-7 col-md-offset-5 text-right">
                                        <span>{{orderInfo.shippingInfo.address.city | titlecase}}</span>
                                    </div>
                                    <div *ngIf="orderInfo.shippingInfo.address.state"
                                        class="col-md-7 col-md-offset-5 text-right">
                                        <span>{{orderInfo.shippingInfo.address.state | titlecase}} -
                                            {{orderInfo.shippingInfo.address.zipCode}}</span>
                                    </div>
                                    <div *ngIf="orderInfo.shippingInfo.address.country"
                                        class="col-md-7 col-md-offset-5 text-right">
                                        <span>{{orderInfo.shippingInfo.address.country | titlecase}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <modal #ticketActivityDetailsModal>
        <modal-header>
            <h4 class="color-blue">{{'ticketing-system.TICKET DETAILS' |translate}}</h4>
        </modal-header>
        <modal-content>
            <div class="" [innerHTML]="ticketActivityChangeData | safeHtml">
            </div>
        </modal-content>
        <modal-footer>
            <div class="pull-right">
                <button class="btn blue-button" type="button" tabindex="0" (keyup.enter)="closeTicketActivityPopup()"
                    (click)="closeTicketActivityPopup()">
                    {{'ticketing-system.Ok' |translate}}
                </button>
            </div>
        </modal-footer>
    </modal>
    <modal #editTicketCancelConfirmationModal>
        <modal-header>
            <h4 class="color-blue">{{'ticketing-system.Confirmation' |translate}}</h4>
        </modal-header>
        <modal-content>
            <div class="">
                {{'ticketing-system.Are you sure you want to clear all the changes?' |translate}}
            </div>
        </modal-content>
        <modal-footer>
            <div class="pull-right">
                <button class="btn blue-button" type="button" tabindex="0" (keyup.enter)="clearTicketForm()"
                    (click)="clearTicketForm()">
                    {{'ticketing-system.CLEAR' |translate}}
                </button>
                <button class="btn blue-button" type="button" tabindex="0"
                    (keyup.enter)="closeEditTicketCancelConfirmationPopup()"
                    (click)="closeEditTicketCancelConfirmationPopup()">
                    {{'ticketing-system.Cancel' |translate}}
                </button>
            </div>
        </modal-footer>
    </modal>
</section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/work-ticket-edit.component.html